// Import packages
import React from "react";
import {Route, Switch, Router, Redirect} from "react-router-dom";

// Import utils
import {history} from "../configs/history";
import {ProtectedRoute} from "./protectedRoute";

// Import pages
import AdminLayout from '../containers/AdminLayout';
import Login from '../containers/Login';

import Dashboard from '../containers/Dashboard';
import AddEditProduct from "../containers/product/AddEditProduct";

import NotFound from '../containers/NotFound';
import Contact from '../containers/Contact';

import Moderators from '../containers/moderators/Moderators';
import AddEditModerator from "../containers/moderators/AddEditModerator";

import Users from '../containers/users/Users';
import UserDetails from "../containers/users/UserDetails";

import Media from "../containers/media/Media";
import EditFile from "../containers/media/EditFile";

import Languages from "../containers/languages/Languages";
import EditLanguage from "../containers/languages/EditLanguage";

import Slider from "../containers/slider/Slider";
import AddEditSlider from "../containers/slider/AddEditSlider";

import Category from "../containers/category/Category";
import AddEditCategory from "../containers/category/AddEditCategory";

import Filters from "../containers/filters/Filters";
import AddFilter from "../containers/filters/AddFilter";
import EditFilter from "../containers/filters/EditFilter";

import Badges from "../containers/badges/Badges";
import AddEditBadge from "../containers/badges/AddEditBadges";

import Partner from "../containers/partners/Partner";
import AddEditPartner from "../containers/partners/AddEditPartner";

import StaticTexts from "../containers/staticTexts/StaticTexts";

import About from "../containers/about/About";

import Blogs from "../containers/blogs/Blogs";
import AddEditBlog from "../containers/blogs/AddEditBlog";
import Subscribe from "../containers/subscribe/Subscribe";

import BrandTypes from "../containers/brandTypes/BrandTypes";
import AddEditBrandTypes from "../containers/brandTypes/AddEditBrandTypes";

import Brand from "../containers/brand/Brand";
import AddEditBrand from "../containers/brand/AddEditBrand";

// import Orders from "../containers/orders/Orders";
// import OrderDetails from "../containers/orders/OrderDetails";
//
// import Status from "../containers/status/Status";
// import AddEditStatus from "../containers/status/AddEditStatus";
//
// import Banner from "../containers/banner/Banner";
// import AddEditBanner from "../containers/banner/AddEditBanner";
//
// import Section from "../containers/section/Section";
// import AddEditSection from "../containers/section/AddEditSection";
//
// import BlogTypes from "../containers/blogTypes/BlogTypes";
// import AddEditBlogTypes from "../containers/blogTypes/AddEditBlogTypes";
// import CustomPages from "../containers/customPages/CustomPages";
// import AddEditCustomPages from "../containers/customPages/AddEditCustomPages";
//
// import Settings from '../containers/Settings';


export default () => {

    return <Router history={history}>
        <Switch>
            <Redirect exact from="/" to="/login"/>
            <Route exact path="/login" component={Login}/>
            <AdminLayout>
                <Switch>
                    <Route exact path="/products" component={Dashboard}/>
                    <ProtectedRoute exact path="/products/add" component={AddEditProduct}/>
                    <ProtectedRoute exact path="/products/edit/:id" component={AddEditProduct}/>

                    <ProtectedRoute exact path="/moderators" component={Moderators}/>
                    <ProtectedRoute exact path="/moderators/add" component={AddEditModerator}/>
                    <ProtectedRoute exact path="/moderators/edit/:id" component={AddEditModerator}/>

                    <ProtectedRoute exact path="/users" component={Users}/>
                    <ProtectedRoute exact path="/users/user/:id" component={UserDetails}/>

                    <ProtectedRoute exact path="/media" component={Media}/>
                    <ProtectedRoute exact path="/media/edit/:id" component={EditFile}/>

                    <ProtectedRoute exact path="/categories" component={Category}/>
                    <ProtectedRoute exact path="/categories/add" component={AddEditCategory}/>
                    <ProtectedRoute exact path="/categories/edit/:id" component={AddEditCategory}/>

                    <ProtectedRoute exact path="/badges" component={Badges}/>
                    <ProtectedRoute exact path="/badges/add" component={AddEditBadge}/>
                    <ProtectedRoute exact path="/badges/edit/:id" component={AddEditBadge}/>

                    <ProtectedRoute exact path="/partners" component={Partner}/>
                    <ProtectedRoute exact path="/partners/add" component={AddEditPartner}/>
                    <ProtectedRoute exact path="/partners/edit/:id" component={AddEditPartner}/>

                    <ProtectedRoute exact path="/slider" component={Slider}/>
                    <ProtectedRoute exact path="/slider/add" component={AddEditSlider}/>
                    <ProtectedRoute exact path="/slider/edit/:id" component={AddEditSlider}/>

                    <ProtectedRoute exact path="/filters" component={Filters}/>
                    <ProtectedRoute exact path="/filters/add" component={AddFilter}/>
                    <ProtectedRoute exact path="/filters/edit/:id" component={EditFilter}/>

                    <ProtectedRoute exact path="/languages" component={Languages}/>
                    <ProtectedRoute exact path="/languages/edit/:id" component={EditLanguage}/>

                    <ProtectedRoute exact path="/contact" component={Contact}/>
                    <ProtectedRoute exact path="/staticTexts" component={StaticTexts}/>

                    <ProtectedRoute exact path="/about" component={About}/>

                    <ProtectedRoute exact path="/blogs" component={Blogs}/>
                    <ProtectedRoute exact path="/blogs/add" component={AddEditBlog}/>
                    <ProtectedRoute exact path="/blogs/edit/:id" component={AddEditBlog}/>

                    <ProtectedRoute exact path="/brand" component={Brand}/>
                    <ProtectedRoute exact path="/brand/add" component={AddEditBrand}/>
                    <ProtectedRoute exact path="/brand/edit/:id" component={AddEditBrand}/>

                    <ProtectedRoute exact path="/brandTypes" component={BrandTypes}/>
                    <ProtectedRoute exact path="/brandTypes/add" component={AddEditBrandTypes}/>
                    <ProtectedRoute exact path="/brandTypes/edit/:id" component={AddEditBrandTypes}/>

                    <ProtectedRoute exact path="/subscribe" component={Subscribe}/>


{/*
                    <ProtectedRoute exact path="/orders" component={Orders}/>
                    <ProtectedRoute exact path="/orders/order/:id" component={OrderDetails}/>

                    <ProtectedRoute exact path="/status" component={Status}/>
                    <ProtectedRoute exact path="/status/add" component={AddEditStatus}/>
                    <ProtectedRoute exact path="/status/edit/:id" component={AddEditStatus}/>

                    <ProtectedRoute exact path="/banner" component={Banner}/>
                    <ProtectedRoute exact path="/banner/add" component={AddEditBanner}/>
                    <ProtectedRoute exact path="/banner/edit/:id" component={AddEditBanner}/>

                    <ProtectedRoute exact path="/section" component={Section}/>
                    <ProtectedRoute exact path="/section/add" component={AddEditSection}/>
                    <ProtectedRoute exact path="/section/edit/:id" component={AddEditSection}/>

                    <ProtectedRoute exact path="/customPages" component={CustomPages}/>
                    <ProtectedRoute exact path="/customPages/add" component={AddEditCustomPages}/>
                    <ProtectedRoute exact path="/customPages/edit/:id" component={AddEditCustomPages}/>

                    <ProtectedRoute exact path="/blogTypes" component={BlogTypes}/>
                    <ProtectedRoute exact path="/blogTypes/add" component={AddEditBlogTypes}/>
                    <ProtectedRoute exact path="/blogTypes/edit/:id" component={AddEditBlogTypes}/>

                    <ProtectedRoute exact path="/settings" component={Settings}/>
                    */}

                    <Route exact path="/404" component={NotFound}/>
                    <Route component={NotFound}/>
                </Switch>
            </AdminLayout>
        </Switch>
    </Router>
}
